<template>
  <div>
    <v-card
      class="flex-grow-1"
      rounded="lg"
      outlined
      :style="'border-color: ' + maincolor">
      <v-container>
        <v-row>
          <v-col cols="12" md="12" class="py-1">
            <div class="d-flex">
              <div class="d-inline mr-5">
                <v-img
                  :lazy-src="require('../assets/default.jpg')"
                  max-height="70"
                  max-width="70"
                  :src="datacom.urlpic ? datacom.urlpic : ''">
                </v-img>
              </div>
              <div class="d-inline">
                <h4 class="text-md-subtitle-1 font-weight-bold">
                  {{ datacom.user_firstname }} {{ datacom.user_lastname }}
                </h4>
                <span class="text-subtitle-2">
                  {{ datacom.js_pref_special ? datacom.js_pref_special : 'Specialization'}}
                </span>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="12" class="py-1">
            <timeago class="caption font-weight-bold" :datetime="datacom.js_update"></timeago>
            <div class="my-1">
              <v-chip
                outlined
                class="mr-1 mb-1"
                color="deep-orange"
                small
                dark>
                {{ datacom.js_pref_salary | rupiahformat }}
              </v-chip>
              <v-chip
                outlined
                class="mr-1 mb-1"
                color="primary"
                small
                dark>
                <v-icon left small>
                  mdi-map-marker
                </v-icon>
                {{ datacom.js_pref_location }}
              </v-chip>
            </div>
          </v-col>
          <v-col cols="12" md="12" class="py-1">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn
              small
              text
              color="teal accent-4"
              @click="showProfile()">
              Profile
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <!-- profile -->
    <v-dialog
      v-model="dmodal.profile"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-card-text class="py-5">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="11">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-row class="black--text">
                    <v-col cols="10" md="10">
                      <div class="d-flex">
                        <div class="d-inline mr-5">
                          <v-img
                            :lazy-src="require('../assets/default.jpg')"
                            max-height="70"
                            max-width="70"
                            :src="datacom.urlpic ? datacom.urlpic : ''">
                          </v-img>
                        </div>
                        <div class="d-inline">
                          <h2 class="text-md-h4 font-weight-bold">
                            {{ datacom.user_firstname }} {{ datacom.user_lastname }}
                          </h2>
                          <span class="text-subtitle-1">
                            {{ datacom.js_pref_special ? datacom.js_pref_special : 'Specialization'}}
                          </span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="2" md="2" :class="$vuetify.breakpoint.smAndDown ? 'text-left' : 'text-right'">
                      <v-btn
                        class="mr-2 mb-2"
                        fab
                        depressed
                        color="error"
                        x-small
                        @click="closeDmodal('profile')">
                        <v-icon dark>
                          mdi-close-thick
                        </v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-tabs
                        v-model="tabprofdata"
                        show-arrows>
                        <v-tabs-slider :color="maincolor"></v-tabs-slider>
                        <v-tab href="#profile" active-class="main-style-slide">
                          Profile
                        </v-tab>
                        <v-tab href="#edu" active-class="main-style-slide">
                          Educations
                        </v-tab>
                        <v-tab href="#exp" active-class="main-style-slide">
                          Experiences
                        </v-tab>
                        <v-tab href="#resume" active-class="main-style-slide">
                          Resume
                        </v-tab>
                      </v-tabs>
                      <v-divider></v-divider>
                      <v-tabs-items :touchless="true" v-model="tabprofdata">
                        <v-tab-item value="profile">
                          <v-card flat>
                            <v-card-text class="px-0">
                              <v-row class="black--text">
                                <v-col cols="12" md="4">
                                  <span class="text-subtitle-1">Expected salary</span>
                                  <h2 class="text-md-h6 font-weight-bold mb-3">
                                    <v-icon :color="maincolor">
                                      mdi-cash-multiple
                                    </v-icon>
                                    {{ datacom.js_pref_salary ? datacom.js_pref_salary : 1 | rupiahformat }}
                                  </h2>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <span class="text-subtitle-1">Location</span>
                                  <h2 class="text-md-h6 font-weight-bold mb-3">
                                    <v-icon :color="maincolor">
                                      mdi-map-marker
                                    </v-icon>
                                    {{ datacom.js_pref_location ? datacom.js_pref_location : 'Location'}}
                                  </h2>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <span class="text-subtitle-1">Update at</span>
                                  <h2 class="text-md-h6 font-weight-bold mb-3">
                                    <v-icon :color="maincolor" class="mr-1">
                                      mdi-calendar-range
                                    </v-icon>
                                    <timeago :datetime="datacom.js_update"></timeago>
                                  </h2>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <span class="text-subtitle-1">Gender</span>
                                  <p class="mb-3">
                                    {{ datacom.js_sex ? datacom.js_sex : 'Male'}}
                                  </p>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <span class="text-subtitle-1">Birthday</span>
                                  <p class="mb-3">
                                    {{ datacom.js_birthdate ? datacom.js_birthdate : 'Today'}}
                                  </p>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <span class="text-subtitle-1">Birthplace</span>
                                  <p class="mb-3">
                                    {{ datacom.js_birthplace ? datacom.js_birthplace : 'Home'}}
                                  </p>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <span class="text-subtitle-1">Address</span>
                                  <p class="mb-3">
                                    {{ datacom.js_address ? datacom.js_address : 'full address'}}
                                  </p>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <span class="text-subtitle-1">Contact</span>
                                  <div class="mb-3">
                                    <v-btn
                                      :href="'tel:' + datacom.js_phone"
                                      class="mr-2"
                                      small
                                      fab
                                      outlined>
                                      <v-icon>
                                        mdi-phone-classic
                                      </v-icon>
                                    </v-btn>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="12" v-show="!$vuetify.breakpoint.smAndDown">
                                  <v-divider></v-divider>
                                </v-col>
                              </v-row>
                              <v-row class="black--text">
                                <v-col cols="12" md="12">
                                  <h2 class="text-md-h5 font-weight-bold mb-3">
                                    About {{ datacom.user_firstname }} {{ datacom.user_lastname }}
                                  </h2>
                                  <div
                                    class="content-editor"
                                    v-html="datacom.js_desc ? datacom.js_desc : 'Description'">
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item value="resume">
                          <v-card flat>
                            <v-card-text class="px-0">
                              <v-row class="black--text">
                                <v-col cols="12" md="12" v-if="datacom.urlresume">
                                  <div class="font-weight-bold">
                                    <v-icon class="mr-1 mb-1">mdi-update</v-icon>
                                    <timeago :datetime="datacom.js_update"></timeago>
                                  </div>
                                  <div class="mt-2">
                                    <iframe
                                      :src="getPdfView(datacom.urlresume)"
                                      style="width:100%; height:700px;"
                                      frameborder="0">
                                    </iframe>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-btn
                        class="mr-3"
                        color="error"
                        small
                        depressed
                        @click="closeDmodal('profile')">
                        Close
                      </v-btn>
                      <v-btn
                        :href="getPdfView(datacom.urlresume)"
                        target="_blank"
                        color="success"
                        small
                        depressed>
                        Download Resume
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import qs from 'qs';
import { mapState } from 'vuex';
import { priceFromat, getGdriveView } from '@/plugins/utils';
import Alertsp from './Alert.vue';
import { VueEditor } from 'vue2-editor';

export default {
  props: ['data'],
  data: () => ({
    datacom: null,
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      interview: false,
      refresh: false,
      apply: false,
      save: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    isapply: false,
    issave: false,
    rules: {
      required: (value) => !!value || 'Required.',
    },
    dmodal: {
      interview: false,
      profile: false,
    },
    dmodaldata: {
      interview: null,
      profile: null,
    },
    tabprofdata: 'profile',
    formadd: {
      valid: false,
    },
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      addinterview: false,
    },
  }),
  created() {
    this.datacom = this.data;
  },
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'userjob',
      'usersjob',
    ]),
  },
  mounted() {
    this.datacom = this.data;
    console.log(this.datacom);
  },
  filters: {
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return '';
      } else {
        return priceFromat(value, 'Rp');
      }
    },
  },
  methods: {
    getPdfView(url) {
      return getGdriveView(url);
    },
    closeDmodal(type) {
      if (type === 'interview') {
        this.dmodal.interview = false;
      } else if (type === 'profile') {
        this.dmodal.profile = false;
      } else {
        this.dmodal.interview = false;
      }
    },
    showProfile() {
      this.dmodal.profile = true;
    },
  },
  components: {
    Alertsp,
    VueEditor,
  },
};
</script>